module.exports = __webpack_public_path__ + "media/images/proposal/top/reason3-6f785d5ca7b37d87f6be2a642cb6f66f.jpg";